module.exports = __webpack_public_path__ + "img/asiyajavayant.31e0b4b8.png";